import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIForm from 'UIComponents/form/UIForm';
import UIBox from 'UIComponents/layout/UIBox';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import { Text } from 'foundations-components/components/Text';
import * as TwoFactorAuthSetupSteps from '../constants/TwoFactorAuthSetupSteps';
import { GOOGLE_AUTHENTICATOR, SMS, SECURITY_PHONE_NUMBER } from '../constants/TwoFactorAuthMethods';
import TwoFactorAuthSMSErrors from '../constants/TwoFactorAuthSMSErrors';
import PhoneInputValidation from './PhoneInputValidation';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class RegisterSMS extends Component {
  constructor(props) {
    super(props);
    this.handleNumberChange = this.handleNumberChange.bind(this);
  }
  handleNumberChange(phoneData) {
    this.props.onNumberChange(phoneData.phoneNumber);
  }
  renderSecurityPhoneNumberDescription() {
    const {
      redirectUrl,
      onSkipPressed
    } = this.props;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.securityPhoneNumber.registerSms.disclaimer"
        })
      }), redirectUrl && /*#__PURE__*/_jsx(View, {
        marginBlockStart: "600",
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "transparent",
          onClick: onSkipPressed,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.securityPhoneNumber.registerSms.skip"
          })
        })
      })]
    });
  }
  render() {
    const {
      method
    } = this.props;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        textAlign: "center",
        paddingBlock: "700",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: method === SECURITY_PHONE_NUMBER ? 'userPreferences.securityPhoneNumber.setup' : `userPreferences.2fa.${TwoFactorAuthSetupSteps.REGISTER_SMS}.contentTitle`
        })
      }), /*#__PURE__*/_jsx(UIFlex, {
        justify: "center",
        children: /*#__PURE__*/_jsxs(UIBox, {
          basis: "400px",
          children: [/*#__PURE__*/_jsx(Text, {
            textAlign: "center",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: method === SECURITY_PHONE_NUMBER ? 'userPreferences.securityPhoneNumber.registerSms.description' : `userPreferences.2fa.${TwoFactorAuthSetupSteps.REGISTER_SMS}.description`
            })
          }), /*#__PURE__*/_jsx(UIForm, {
            children: /*#__PURE__*/_jsx(Text, {
              textAlign: "start",
              paddingBlockStart: "600",
              children: /*#__PURE__*/_jsx(PhoneInputValidation, {
                error: this.props.error,
                number: this.props.number,
                onKeyUp: this.props.onKeyUp,
                onNumberChange: this.props.onNumberChange
              })
            })
          }), method === SECURITY_PHONE_NUMBER && this.renderSecurityPhoneNumberDescription()]
        })
      })]
    });
  }
}
RegisterSMS.propTypes = {
  error: PropTypes.oneOf(Object.keys(TwoFactorAuthSMSErrors)),
  number: PropTypes.string.isRequired,
  onKeyUp: PropTypes.func.isRequired,
  onNumberChange: PropTypes.func.isRequired,
  method: PropTypes.oneOf([GOOGLE_AUTHENTICATOR, SMS, SECURITY_PHONE_NUMBER]),
  redirectUrl: PropTypes.string,
  onSkipPressed: PropTypes.func
};
export default RegisterSMS;